import { Component, Input, OnDestroy } from '@angular/core';
import { NgControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import {
	FormConfig,
	CustomFormAccessor,
} from 'src/shared/form-models/form-cva.component';
import { BillingCompany } from '../billing-details.models';
import { Company, Railroad, Customer } from 'src/shared/api';
import { takeUntil, map } from 'rxjs/operators';
import {
	mapCompanyToBillingCompany,
	mapBillingCompanyToCompany,
	mapRailroadOrCustomerToCompany,
} from '../billing-details.utility';

const billingCompanyFormConfig: FormConfig<BillingCompany> = {
	id: [''],
	name: ['', Validators.required],
	employerIdentificationNumber: [''],
	contactId: [''],
	contactFirstName: ['', Validators.required],
	contactLastName: ['', Validators.required],
	phoneNumberId: [''],
	phoneNumber: [''],
	address: [''],
};

@Component({
	selector: 'rpshared-billing-company',
	templateUrl: './billing-company.component.html',
})
export class BillingCompanyComponent
	extends CustomFormAccessor<Company | BillingCompany>
	implements OnDestroy {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, billingCompanyFormConfig);
	}

	writeValue(value: Company): void {
		const billingCompany = mapCompanyToBillingCompany(value);
		this.form.reset(billingCompany, { emitEvent: false });
	}

	registerOnChange(fn: (value: BillingCompany | Company) => void) {
		this.form.valueChanges
			.pipe(map(mapBillingCompanyToCompany), takeUntil(this.destroyed))
			.subscribe(fn);
	}

	ngOnDestroy() {
		this.form.disable();
		super.ngOnDestroy();
	}
}
@Component({
	selector: 'rpshared-billing-company-readonly',
	templateUrl: './billing-company.component.html',
})
export class ReadonlyBillingCompanyComponent {
	@Input() set company(company: Railroad | Customer) {
		if (company) {
			this.form.patchValue(mapRailroadOrCustomerToCompany(company));
			this.form.disable();
		} else {
			this.form.reset();
			this.form.disable();
		}
	}

	readonly form = this.fb.group(billingCompanyFormConfig) as FormGroup;

	constructor(private readonly fb: FormBuilder) {}
}
